import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Bookings from './pages/Bookings';
import Schedules from './pages/Schedules';
import RoutesPage from './pages/Routes';
import Customers from './pages/Customers';
import Upload from './pages/Upload';

const NotFound = () => (
  <div className="text-center py-8">
    <h2 className="text-2xl font-bold text-gray-900">Page Not Found</h2>
    <p className="mt-2 text-gray-600">The page you're looking for doesn't exist.</p>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <RouterRoutes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <RouterRoutes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/bookings" element={<Bookings />} />
                  <Route path="/schedules" element={<Schedules />} />
                  <Route path="/routes" element={<RoutesPage />} />
                  <Route path="/customers" element={<Customers />} />
                  <Route path="/upload" element={<Upload />} />
                  <Route path="*" element={<NotFound />} />
                </RouterRoutes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </RouterRoutes>
    </AuthProvider>
  );
}

export default App;